import { render, staticRenderFns } from "./IntegrationsPlatform.vue?vue&type=template&id=eca8b848"
import script from "./IntegrationsPlatform.vue?vue&type=script&lang=js"
export * from "./IntegrationsPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports